<template>
  <TableList
    v-rect-loading="loading"
    class="company-management-list"
    row-key="id"
    :title="$t(`${i18nPrefix}.title.companyManagement`)"
    :listData="dataList"
    :cellStyle="cellStyle"
    :tableColumns="tableColumns"
    :actionBtn="actionBtn"
    :showCreateBtn="false"
  >
    <template #filter>
      <div class="header-left">
        <span class="text">{{ $t(`${i18nPrefix}.label.companyName`) }}</span>
        <span class="company-select">
          <el-select v-model="selectCompany" filterable clearable @change="handleCompanySelect">
            <el-option
              v-for="item in companyList"
              :key="item.id"
              :label="item.i18nName"
              :style="{ paddingLeft: item.level * 15 + 'px' }"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </span>
      </div>
    </template>
    <template #btn>
      <el-button class="blue-btn" @click="handelAddCompany">{{ $t(`${i18nPrefix}.btn.addCompany`) }}</el-button>
    </template>
    <template #page-bottom>
      <DialogWrapper
        saveBtnLabelI18nKey="common.btn.confirm"
        closeOnCancel
        :title="$t(`${i18nPrefix}.message.deleteConfirm`, { companyName: deleteCompanyInfo.i18nName })"
        :loading="deleteDialog.loading"
        :show.sync="deleteDialog.show"
        @save="handleDelete"
      >
      </DialogWrapper>
    </template>
  </TableList>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import { addI18nProperty, isEn } from '@/i18n'
import TableList from '@/components/tableList/allowDragSortTable.vue'
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'

export default {
  components: {
    TableList,
    DialogWrapper
  },
  data () {
    return {
      i18nPrefix: 'admin.company.companyManagement',
      loading: false,
      isEn,
      dataList: [],
      companyList: [],
      selectCompany: null,
      rootCompanyId: null,
      actionBtn: {
        edit: {
          show: true,
          onclick: this.handleEditCompany
        },
        delete: {
          show: this.isShowDeleteBtn,
          onclick: this.handleDeleteCompany
        }
      },
      deleteDialog: {
        show: false,
        loading: false
      },
      deleteCompanyInfo: {},
      currentCompanyId: null
    }
  },
  computed: {
    tableColumns () {
      const columns = [
        {
          label: this.$t(`${this.i18nPrefix}.label.name`),
          dataKey: 'name',
          width: '300',
          showOverflowTooltip: true
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.cnName`),
          dataKey: 'cn_name',
          width: '300',
          showOverflowTooltip: true
        }
      ]
      return columns
    },
    languageCode () {
      return this.$i18n.locale
    },
    totalStatusTitle () {
      return this.$t(`${this.i18nPrefix}.message.userTip`, { activeCount: this.activeCount, totalCount: this.totalCount })
    }
  },
  created () {
    this.initData()
  },
  methods: {
    ...mapActions('companyManagement', ['deleteCompany']),
    ...mapActions('company', ['getCompanyChildrenTree']),
    async initData () {
      this.loading = true
      try {
        await this.loadCompanyList()
        this.getCompanyFromUrl()
        await this.loadDataList()
      } finally {
        this.loading = false
      }
    },
    async loadCompanyList () {
      const companyTreeResp = await this.getCompanyChildrenTree({ is_all: 1 })
      const currentCompany = {
        id: companyTreeResp.self.id,
        name: companyTreeResp.self.name,
        cn_name: companyTreeResp.self.cn_name,
        level: companyTreeResp.self.level
      }
      this.selectCompany = currentCompany.id
      this.currentCompanyId = currentCompany.id
      this.rootCompanyId = companyTreeResp.root?.id
      const companyList = []
      this.companyList = this.formatCompanyData(companyTreeResp.children, currentCompany, companyList)
    },
    async loadDataList () {
      try {
        this.loading = true
        const resp = await this.getCompanyChildrenTree({ company_id: this.selectCompany, is_all: 1 })
        const dataList = []
        this.dataList = this.formatCompanyData(resp.children, resp.self, dataList)
      } finally {
        this.loading = false
      }
    },
    cellStyle ({ row, columnIndex }) {
      if (columnIndex !== 2) {
        return { paddingLeft: (row.level - 1) * 15 + 'px' }
      }
    },
    handleCompanySelect () {
      this.handleRouteChange(true)
    },
    formatCompanyData (allCompany, company, companyList) {
      addI18nProperty(company, 'i18nName', 'cn_name', 'name')
      companyList.push(company)
      const children = allCompany[company.id]
      if (children && children.length > 0) {
        _.forEach(children, (child) => {
          this.formatCompanyData(allCompany, child, companyList)
        })
      }
      return companyList
    },
    isShowDeleteBtn (rowData, index) {
      if (rowData.id === this.selectCompany) {
        return false
      }
      return true
    },
    handleDeleteCompany (row) {
      this.deleteCompanyInfo = row
      this.deleteDialog.show = true
    },
    async handleDelete () {
      this.deleteDialog.loading = true
      try {
        const resp = await this.deleteCompany(this.deleteCompanyInfo.id)
        if (resp) {
          this.$message.success(this.$t(`${this.i18nPrefix}.message.optionSuccess`))
        }
        this.deleteDialog.show = false
      } finally {
        this.deleteDialog.loading = false
      }
      await this.initData()
    },
    handelAddCompany () {
      this.$router.push({ path: '/v-admin/company/management/add', query: { company: this.selectCompany || this.currentCompanyId } })
    },
    handleEditCompany (row) {
      this.$router.push({ path: `/v-admin/company/management/edit/${row.id}`, query: { company: this.selectCompany || this.currentCompanyId } })
    },
    getCompanyFromUrl () {
      const selectCompany = parseInt(this.$route.query.company)
      if (selectCompany) {
        this.selectCompany = selectCompany
      }
      this.handleRouteChange()
    },
    handleRouteChange (isPush) {
      const selectCompany = this.$route.query.company
      if ((selectCompany || this.selectCompany) && parseInt(selectCompany) !== this.selectCompany) {
        isPush
          ? this.$router.push({ query: { company: this.selectCompany } })
          : this.$router.replace({ query: { company: this.selectCompany } })
      }
    }
  },
  watch: {
    $route () {
      this.getCompanyFromUrl()
      this.loadDataList()
    }
  }
}
</script>

<style lang="scss" scoped>
.company-management-list {

  .statistics {
    display: inline-block;

    .success-icon {
      font-size: 20px;
      color: #0096cc;
      vertical-align: middle;
      margin-right: 5px;
    }

    .error-icon {
      font-size: 17px;
      color: #aaa;
      vertical-align: middle;
      margin-right: 5px;
    }

    .statistics-count {
      border-right: 1px solid #aaa;
      margin-right: 10px;
      padding-right: 10px;
      vertical-align: middle;
    }
  }
  .header-left {
    display: inline-block;
    vertical-align: middle;
    .text {
      margin-right: 10px;
      display: inline-block;
      vertical-align: middle;
    }

    .company-select {
      display: inline-block;
      vertical-align: middle;
    }
  }

}
</style>
